export const initialState = {
  activeModals: [],
  modalsData: {}
}
